/* eslint-disable dot-notation */
/* eslint-disable no-negated-condition */
import { useState, useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import { Message } from "@twilio/conversations";
import log from "loglevel";
import { Box } from "@twilio-paste/core";

import Buttons from "./Botones";
import { AppState } from "../store/definitions";



const defaultCurInteractives = { type: "" };


const Interactives = ({ messageList, channelSid }: { messageList: any; channelSid: any }) => {
    const interactivesContainer = useRef(null);

    const [curInteractives, setCurInteractives] = useState(defaultCurInteractives);

    useEffect(() => {
        const actions = messageList[messageList.length - 1].state.attributes.interactiveWebchatOptions;
        console.log(actions);

        if (messageList.length > 0 && (messageList[messageList.length - 1].state.author === "Survey") && actions) {
            const lastMessageAttributes: any = messageList[messageList.length - 1].state.attributes.interactiveWebchatOptions;
            setCurInteractives(lastMessageAttributes);
        } else {
            setCurInteractives(defaultCurInteractives);
        }
    }, [messageList]);

    useEffect(() => {
        if (curInteractives !== defaultCurInteractives) {
            interactivesContainer.current!;
        }
    }, [curInteractives]);


    const { conversation } = useSelector((state: AppState) => ({
        conversation: state.chat.conversation
    }));


    const send = async (text: any) => {
        if (!conversation) {
            log.error("Failed sending message: no conversation found");
            return;
        }
        
        let preparedMessage = conversation.prepareMessage();
        preparedMessage = preparedMessage.setBody(text);

        await preparedMessage.build().send();
    };
    

    // Functions
    const sendMessageSurvey = async (messageText: { message: Message[] }) => {
        await send(messageText);
    };

    // Render
    return (
        <Box>
            {curInteractives !== defaultCurInteractives ? (
                <div ref={interactivesContainer}>
                    (<Buttons curInteractives={curInteractives} sendMessageSurvey={sendMessageSurvey} />)
                </div>
            ) : (
                <></>
            )}
        </Box>
    );
};

// Redux
const mapStateToProps = (state: AppState) => {
    return {
        messageList: state.chat.messages,
        channelSid: state.session.conversationSid
    };
};
export default connect(mapStateToProps)(Interactives);
